import { Profile } from "../shared/profile.model";

export class Community {
  id: string;
  name: string;
  summary: string;
  description: string;
  image: string;
  memberCount: number;
  discussionCount: number;
  tagList: Array<string> = [];
  founder: Profile;
  isMember: boolean;
  createdAt: string;
  updatedAt: string;
}
